import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import Layout from 'wobi-web-common/dist/components/Layout';
import {Breakpoints} from 'wobi-web-common';
import Header from './components/Header';
import MainContainer from './components/MainContainer';
import Routes from './components/Routes';
import DestBackdrop from './components/DestBackdrop';
import SideBar from './steps/SideBar';
import withStepGuardMiddleware from './utils/StepGuardMiddleware';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';
import {setOffersFields} from './utils/persistOfferDetails';

import {createBrowserHistory} from 'history';
import patchBlockFn from 'history-block-async';
import AiCompanion from './components/AiCompanion';
import {AI_CHAT_ENABLED} from './config/features';

const App = ({location}) => {
  const isMobile = useMediaQuery(`(max-width:${Breakpoints.mobile}px)`);
  const [renderSideBar, setRenderSideBar] = React.useState(true);
  const changeSideBar = setRenderSideBar;
  React.useEffect(() => {
    // save the agentDeveloperName in the session storage
    const agentDeveloperName = agentDeveloperUtils.agentData.Agent_Developer_Name_c;
    setOffersFields({agentDeveloperName});
  });

  React.useEffect(() => {
    agentDeveloperUtils.replaceWobiWithAgentName(document);
  });

  React.useEffect(() => {
    const intervalId = window.setInterval(() => {
      agentDeveloperUtils.replaceWobiWithAgentName(document);
    }, 500);

    return () => window.clearInterval(intervalId);
  }, []);

  const path = (/#!(\/.*)$/.exec(location.hash) || [])[1];
  const search = (/\?(.*)$/.exec(location.hash) || [])[1];

  const history = createBrowserHistory();
  if (path) {
    history.replace(path);
    if (search) {
      location.search = '?' + search;
      location.hash = '';

      location.pathname = path.replace('?' + search, '');
    } else {
      location.pathname = decodeURIComponent(path);
    }
  }

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  const isThankYou = location.pathname === '/thank-you';
  const isDetails = ['/details', '/initial-details'].includes(location.pathname);
  const showDestinationBackdrop = !isThankYou && location.pathname !== '/offers';
  const containerVariant = isThankYou ? 'thankYou' : location.pathname === '/offers' ? 'offers' : '';

  return (
    <MainContainer variant={containerVariant}>
      <Header isMobile={isMobile}/>
      {showDestinationBackdrop && <DestBackdrop />}
      <Layout
        sidebar={!isThankYou && !isDetails && location.pathname !== '/offers' && renderSideBar ? <SideBar/> : false}>
        <Routes location={location} changeSideBar={changeSideBar}/>
      </Layout>
      {AI_CHAT_ENABLED && <AiCompanion/>}
    </MainContainer>
  );
};

App.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string,
  }).isRequired,
};

export default withStepGuardMiddleware(App);
